import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../../components/UI/Sidebar/Sidebar";
import styled from "@emotion/styled";
import { Menu } from "lucide-react";
import assets from "../../assets/assets";
import Ripples from "react-ripples";
import axios from "axios";
import { distributionUrl } from "../Config/url";
import { usePasswordAxiosConfig } from "../Config/axios";
import { useCookies } from "react-cookie";
import KaraokeSidebar from "../UI/Sidebar/KaraokeSidebar";
const FixedWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1001;
  background: #00000066;
  .logout-confirmation {
    width: 540px;
    background: #ffffff;
    border-radius: 12px;
    padding: 48px 72px;
  }
  @media (max-width: 767px) {
    .logout-confirmation {
      width: calc(100vw - 32px);
      padding: 32px 20px;
    }
  }
  .logout-cancel-button {
    border: 1px solid #6b7280;
    border-radius: 8px;
    cursor: pointer;
    height: 48px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logout-cancel-button:hover {
    border: 1px solid #ffffff;
    background: #d6d6d6;
  }
  .logout-button {
    border: 1px solid #0061ff;
    border-radius: 8px;
    cursor: pointer;
    background-color: #0061ff;
    color: white;
    height: 48px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .logout-button:hover {
    border: 1px solid #0061ffcc;
    background: #0061ffcc;
  }
`;

const Layout = ({
  isMobileScreen,
  sidebarMobileExpanded,
  sidebarExpanded,
  setSidebarExpanded,
  setSidebarMobileExpanded,
  currentPublisher,
}) => {
  const location = useLocation();
  const [logoutConfirmation, setLogoutConfirmation] = useState(false);
  const [cookie, setCookie, removeCookie] = useCookies();
  const axiosConfig = usePasswordAxiosConfig();
  const navigate = useNavigate();
  const isKaraokePath = location.pathname.startsWith("/karaoke");

  // Хуудас солигдоход mobile drawer-ийг хаана
  useEffect(() => {
    setSidebarMobileExpanded(false);
  }, [location.pathname, setSidebarMobileExpanded]);

  const logoutHandler = () => {
    axios
      .delete(distributionUrl + "panel-oauth/oauth/logout", axiosConfig)
      .then((res) => {
        if (res.status === 200) {
          removeCookie("mmusic_token");
          removeCookie("who_am_i");
          localStorage.clear();
          sessionStorage.clear();
          navigate("/login");
        }
      })
      .catch((err) => {
        localStorage.clear();
        sessionStorage.clear();
        removeCookie("who_am_i");
        removeCookie("mmusic_token");
        navigate("/login");
      });
  };

  return (
    <div
      className={`container duration-400 ${
        isMobileScreen
          ? ""
          : sidebarExpanded
          ? "pl-sidebar-expanded"
          : "pl-sidebar-collapsed"
      }`}
    >
      {/* <h5 className="text-2xl font-bold">
           DEVTOOLS: {devtoolsInfo}
         </h5> */}
      {isMobileScreen && (
        <div className="sticky top-0 z-[90] flex flex-row items-center gap-3 h-14 px-4 bg-sidebar">
          <button
            type="button"
            aria-label="Цэс нээх"
            className="p-1 -ml-1 text-white"
            onClick={() => setSidebarMobileExpanded(true)}
          >
            <Menu size={26} />
          </button>
          <img
            src={
              isKaraokePath
                ? assets.svg.mkaraokeLogoWhiteSmall
                : assets.svg.mmusicLogoWhiteSmall
            }
            alt=""
            className="h-8"
          />
        </div>
      )}
      {isMobileScreen && sidebarMobileExpanded && (
        <div
          className="fixed inset-0 z-[100] bg-black/50"
          onClick={() => setSidebarMobileExpanded(false)}
        />
      )}
      {isKaraokePath ? (
        <KaraokeSidebar
          sidebarExpanded={sidebarExpanded}
          setSidebarExpanded={setSidebarExpanded}
          currentPublisher={currentPublisher}
          setLogoutConfirmation={setLogoutConfirmation}
          drawer={isMobileScreen}
          drawerOpen={sidebarMobileExpanded}
        />
      ) : (
        <Sidebar
          sidebarExpanded={sidebarExpanded}
          setSidebarExpanded={setSidebarExpanded}
          currentPublisher={currentPublisher}
          setLogoutConfirmation={setLogoutConfirmation}
          drawer={isMobileScreen}
          drawerOpen={sidebarMobileExpanded}
        />
      )}
      <Outlet />
      {logoutConfirmation ? (
        <FixedWrapper
          onClick={() => {
            setLogoutConfirmation(false);
          }}
        >
          <div className="flex flex-col items-center justify-center w-full h-full">
            <div className="logout-confirmation">
              <h5
                className="font-medium text-center pb-8"
                style={{ fontSize: "28px", lineHeight: "2rem" }}
              >
                Системээс гарах
              </h5>
              <h5 className="text-base text-center pb-8">
                Та гарахдаа итгэлтэй байна уу?
              </h5>
              <div className="flex flex-row gap-8 justify-around">
                <Ripples
                  color="#FFFFFF40"
                  during={600}
                  className="w-full h-full rounded-lg"
                >
                  <div
                    className="logout-button"
                    onClick={() => {
                      logoutHandler();
                    }}
                  >
                    <h5 className="text-sm font-medium py-2 px-4">Тийм</h5>
                  </div>
                </Ripples>
                <Ripples
                  color="#0061FF40"
                  during={600}
                  className="w-full h-full rounded-lg"
                >
                  <div
                    className="logout-cancel-button"
                    onClick={() => {
                      setLogoutConfirmation(false);
                    }}
                  >
                    <h5 className="text-sm font-medium py-2 px-4">Үгүй</h5>
                  </div>
                </Ripples>
              </div>
            </div>
          </div>
        </FixedWrapper>
      ) : (
        ""
      )}
    </div>
  );
};

export default Layout;
